import { Oriented } from "@/data/constants/oriented";
import { Translation } from "@/data/lang";

export const getEnterOptions = ({ t }: { t: Translation }): string[] => [
  t.analysis.shared.scoreOption.getScoreMore(4),
  t.analysis.shared.scoreOption.getScoreLabel(5),
];

export const getExitOptions = ({
  t,
  oriented,
}: {
  t: Translation;
  oriented: Oriented;
}): string[] => {
  if (oriented === "value") {
    return [
      t.analysis.shared.scoreOption.getScoreLabel(1),
      t.analysis.shared.scoreOption.getScoreLess(2),
      t.analysis.shared.scoreOption.getScoreLess(3),
    ];
  }

  return [
    t.analysis.shared.scoreOption.getScoreLabel(1),
    t.analysis.shared.scoreOption.getScoreLess(2),
  ];
};
